import { createSlice } from '@reduxjs/toolkit';

import { logout as logoutAPI } from './requests';
import { auth as authAPI } from './requests';
import { loginUrl } from './urls';
import { push } from 'connected-react-router';
import { homeUrl } from '../Home/urls';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    failed: false,
    forbidden: false,
    message: '',
  },
  reducers: {
    setFailed: (state, action) => {
      state.failed = true;
      state.forbidden = false;
      state.message = action.payload;
    },
    setForbidden: (state) => {
      state.forbidden = true;
    },
    clear: (state) => {
      state.failed = false;
      state.forbidden = false;
    },
  },
});

export const { setFailed, setForbidden, clear } = loginSlice.actions;

export function login(email: string, pw: string) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();

    authAPI(email, pw).then((response: (string | boolean)[]) => {
      if (response[0]) {
        dispatch(push(homeUrl()));
      } else {
        dispatch(setFailed(response[1]));
      }
    });
  }
}

export function logout() {
  return (dispatch: (f: any) => void) => {
    logoutAPI().then((result: any) => {
      dispatch(clear());
      dispatch(push(loginUrl()));
    })
  }
}

export function gotoLogin() {
  return (dispatch: (f: any) => void) => {
    dispatch(push(loginUrl()));
  }
}

export function gotoLoginForForbidden() {
  return (dispatch: (f: any) => void) => {
    dispatch(setForbidden());
    dispatch(push(loginUrl()));
  }
}

export default loginSlice.reducer
